import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PackageBundleDetailsProps } from "_interfaces/phoneBooking";

type RechargeDataProps = {
  phoneNumber: string;
  data: PackageBundleDetailsProps | null;
};

type Props = {
  rechargeData: RechargeDataProps;
};

const initialState: Props = {
  rechargeData: {
    phoneNumber: "",
    data: null,
  },
};

const rechargePlanSlice = createSlice({
  name: "rechargePlan",
  initialState,
  reducers: {
    DispatchRechargeData(
      state,
      action: PayloadAction<Partial<RechargeDataProps> | null>
    ) {
      const payload = action.payload;

      if (!payload) {
        // reset to initial
        state.rechargeData = initialState.rechargeData;
        return;
      }

      // update phone number if provided
      if (payload.phoneNumber !== undefined) {
        state.rechargeData.phoneNumber = payload.phoneNumber;
      }

      // update data (supports null)
      if (payload.data !== undefined) {
        state.rechargeData.data = payload.data; // will set null if null
      }
    },
  },
});

export const { DispatchRechargeData } = rechargePlanSlice.actions;

export default rechargePlanSlice.reducer;
